import { DraggingCollapseControl, IDraggableElement } from '@aon/aon-tws-common-ui';
import { DragEndEvent } from '@dnd-kit/core';
import arrayMove from 'array-move';
import React, { CSSProperties, ReactElement } from 'react';
import Constants from '../constants';
import ContentConstants from '../contentConstants';

const getSortedElements = (
	contentItemsOrder: string,
	surveyPrivacy: boolean | JSX.Element,
	surveyInstruction: JSX.Element,
	surveyDefinition: boolean | JSX.Element,
	disabled?: boolean,
	contentItemModalPop?: string,
): IDraggableElement[] => {
	const result: IDraggableElement[] = [];
	const privacyPolicyElement: IDraggableElement = {
		id: 'PrivacyPolicy',
		disabled: disabled ?? false,
		itemStyle:
			contentItemModalPop && contentItemModalPop.indexOf('PrivacyPolicy') >= 0
				? ({ position: 'relative', zIndex: 2 } as CSSProperties)
				: {},
		keyIndex: 0,
		reactElement: surveyPrivacy as ReactElement,
		alterElementInDragging: (
			<DraggingCollapseControl
				title={ContentConstants.SUBSECTIONHEADERS_PRIVACYPOLICY}
				content={ContentConstants.INPUTLABEL_PRIVACY_POLICY}
			></DraggingCollapseControl>
		),
	};
	const definitionElement = {
		id: 'Definition',
		keyIndex: 2,
		itemStyle:
			contentItemModalPop && contentItemModalPop.indexOf('survey-term') >= 0 ? ({ position: 'relative', zIndex: 2 } as CSSProperties) : {},
		disabled: disabled ?? false,
		reactElement: surveyDefinition as ReactElement,
		alterElementInDragging: (
			<DraggingCollapseControl
				title={ContentConstants.SUBSECTIONHEADERS_SURVEY_DEFINITIONS}
				content={ContentConstants.INPUTLABEL_SURVEY_DEFINITIONS}
			></DraggingCollapseControl>
		),
	};
	const instructionElement = {
		id: 'Instructions',
		keyIndex: 1,
		itemStyle:
			contentItemModalPop && contentItemModalPop.indexOf('Instruction') >= 0 ? ({ position: 'relative', zIndex: 2 } as CSSProperties) : {},
		disabled: disabled ?? false,
		reactElement: surveyInstruction as ReactElement,
		alterElementInDragging: (
			<DraggingCollapseControl
				title={ContentConstants.SUBSECTIONHEADERS_SURVEYINSTRUCTIONS}
				content={ContentConstants.INPUTLABEL_SURVEY_INSTRUCTIONS}
			></DraggingCollapseControl>
		),
	};

	if (!contentItemsOrder) {
		result.push(privacyPolicyElement);
		result.push(instructionElement);
		result.push(definitionElement);
		return result;
	}

	const contentItemsOrderList: string[] = contentItemsOrder.split('|');
	for (const contentItem of contentItemsOrderList) {
		let sortItem = null;
		switch (contentItem) {
			case 'PrivacyPolicy':
				sortItem = privacyPolicyElement;
				break;
			case 'Definition':
				sortItem = definitionElement;
				break;
			case 'Instructions':
				sortItem = instructionElement;
				break;
			default:
				break;
		}
		if (sortItem) result.push(sortItem);
	}
	result.forEach((x, i) => (x.keyIndex = i));
	return result;
};

const getNewSortedString = (preSortOrder: string, event: DragEndEvent) => {
	const { active, over } = event;
	if (over && active.id !== over.id) {
		const fullSortOrder =
			!preSortOrder || preSortOrder == ''
				? Constants.PRIVACYPOLICY + '|' + Constants.INSTRUCTIONS + '|' + Constants.DEFINITION
				: preSortOrder;
		const newOrderArr = fullSortOrder.split('|');
		const oldIndex = newOrderArr.findIndex((x) => x === active.id);
		const newIndex = newOrderArr.findIndex((x) => x === over.id);
		const sortedArray = arrayMove(newOrderArr, oldIndex, newIndex);
		return sortedArray.join('|');
	} else return preSortOrder;
};

export const SurveyContentHelper = {
	getSortedElements,
	getNewSortedString,
};
